<template>
	<div>
		<div class="text-left d-flex  px-3 overflow-x-auto" style="flex-flow: wrap;">
			<v-select
				v-model="form.place"
				:items="selectedPlace ? [selectedPlace] : places"
				label="Seleccione un establecimiento"
				no-data-text="No hay establecimientos creados"
				dense
				filled
				outlined
				persistent-hint
				hint="Selecione el lugar donde creará la actividad"
				class="mr-2 my-2"
				style="max-width: 250px"
			></v-select>
			<v-menu
				v-model="menu"
				:close-on-click="false"
				:close-on-content-click="false"
				max-width="290"
				top
			>
				<template v-slot:activator="{ on, attrs }">
					<v-combobox
						v-model="datePickerText"
						:multiple="!editMode || (editMode && dates[0] == dates[1])"
						chips
						small-chips
						label="Seleccione sus fechas"
						append-icon="mdi-calendar"
						readonly
						dense
						filled
						class="mr-2 my-2"
						style="max-width: 200px"
						outlined
						persistent-hint
						hint="Rango de dias o dias que se creará la actividad"
						v-bind="attrs"
						v-on="on"
					>
						<template v-slot:append>
							<v-btn v-if="dates.length" small icon text @click="dates = []">
								<v-icon key="icon-clear">mdi-close</v-icon>
							</v-btn>
							<v-icon v-else key="icon-cal">mdi-calendar</v-icon>
						</template>
						<template v-slot:append-outer v-if="dates">
							<v-slide-x-reverse-transition mode="out-in">
								<v-icon
									key="icon-dates"
									:color="Boolean(dates.length > 1) ? 'success' : 'info'"
									v-text="
										Boolean(dates.length > 1)
											? 'mdi-check-outline'
											: 'mdi-circle-edit-outline'
									"
								>
								</v-icon>
							</v-slide-x-reverse-transition>
						</template>
					</v-combobox>
				</template>
				<v-date-picker
					v-model="datePicker"
					:events="arrayEvents"
					event-color="primary"
					outlined
					:range="radioDatePicker == 'Seleccionar por rango'"
					:multiple="radioDatePicker == 'Seleccionar por dia'"
					locale="es"
					no-title
				>
					<v-row no-gutters>
						<v-col cols="10">
							<v-radio-group
								v-if="!editMode"
								hide-details
								class="mt-0"
								row
								v-model="radioDatePicker"
								@change="() => (datePicker = [])"
							>
								<v-radio
									v-for="item in ['Seleccionar por rango', 'Seleccionar por dia']"
									:key="item"
									:label="item"
									:value="item"
								></v-radio>
							</v-radio-group>
							<div class="text-left caption text--secondary">
								Para seleccionar un unico dia presione dos veces
							</div>
						</v-col>
						<v-col cols="2">
							<v-btn
								x-small
								:disabled="
									(datePicker.length != 2 &&
										radioDatePicker == 'Seleccionar por rango') ||
										!datePicker.length
								"
								depressed
								color="primary"
								@click="setDateInput"
							>
								OK
							</v-btn>
							<v-btn
								class="mt-2"
								icon
								x-small
								text
								color="primary"
								@click="menu = false"
							>
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-col>
					</v-row>
				</v-date-picker>
			</v-menu>
			<v-autocomplete
				v-model="form.person"
				:search-input.sync="searchPerson"
				:items="itemsAutocompletePersons"
				:filter="personFilter"
				label="Persona"
				:multiple="!editMode"
				outlined
				dense
				class="mr-2 mt-2"
				style="max-width: 300px"
				filled
				persistent-hint
				hint="Persona o personas a cargo de la actividad"
				@change="hasChangePerson"
				append-icon="mdi-card-account-details"
			>
				<template v-slot:selection="data">
					<v-chip
						small
						:key="JSON.stringify(data.item.value)"
						v-bind="data.attrs"
						:input-value="data.selected"
						:disabled="data.disabled"
					>
						<span class="caption">{{ data.item.text }}</span>
					</v-chip>
				</template>
				<template v-slot:append-outer>
					<v-slide-x-reverse-transition mode="out-in">
						<v-icon
							key="icon-person"
							:color="form.person ? 'success' : 'info'"
							v-text="form.person ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"
						>
						</v-icon>
					</v-slide-x-reverse-transition>
				</template>
				<template v-slot:no-data>
					<v-list-item @click="() => (dialogPerson = true)">
						<v-btn x-small text class="caption">
							Presiona aqui para agregar a {{ searchPerson }}
						</v-btn>
					</v-list-item>
				</template>
			</v-autocomplete>
			<v-dialog v-model="dialogPerson" transition="dialog-bottom-transition" max-width="800">
				<v-card>
					<v-toolbar color="primary" flat dark>
						Nueva persona
						<v-spacer></v-spacer>
						<v-btn text fab @click="dialogPerson = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar>
					<v-card-text>
						<createPerson
							:close="() => (dialogPerson = false)"
							:setPerson="setPerson"
							:namePerson="searchPerson"
						/>
					</v-card-text>
				</v-card>
			</v-dialog>
			<v-combobox
				:items="itemsAutocompletePeriods"
				label="Periodo*"
				outlined
				dense
				filled
				class="mr-2 mt-2"
				style="max-width: 200px"
				persistent-hint
				hint="Agrupará actividades en el cronograma"
				append-icon="mdi-chart-timeline"
				:search-input.sync="form.group"
				:value="form.group"
			>
				<template v-slot:append-outer>
					<v-slide-x-reverse-transition mode="out-in">
						<v-icon
							:key="`icon-${form.group}`"
							:color="Boolean(form.group) ? 'success' : 'info'"
							v-text="form.group ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"
						></v-icon>
					</v-slide-x-reverse-transition>
				</template>
			</v-combobox>
			<v-combobox
				:search-input.sync="form.room"
				:items="itemsAutocompleteRooms"
				label="Etiqueta*"
				outlined
				dense
				style="max-width: 230px"
				class="mr-2 mt-2 "
				filled
				persistent-hint
				hint="Información adicional"
				:value="form.room"
				append-icon="mdi-tag-text"
			>
				<template v-slot:append-outer>
					<v-slide-x-reverse-transition mode="out-in">
						<v-icon
							:key="`icon-${form.room}`"
							:color="Boolean(form.room) ? 'success' : 'info'"
							v-text="form.room ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"
						></v-icon>
					</v-slide-x-reverse-transition>
				</template>
			</v-combobox>
			<v-select
				v-model="form.color"
				label="Color (Opcional)"
				class="input-prices mr-2 mt-2"
				:items="itemsColor"
				filled
				persistent-hint
				hint="Personaliza"
				outlined
				dense
				style="max-width: 100px"
			>
				<template v-slot:selection="data">
					<div
						v-bind="data.attrs"
						:input-value="data.selected"
						:key="JSON.stringify(data.item)"
					>
						<v-badge :color="data.item"></v-badge>
					</div>
				</template>
				<template v-slot:item="{ item }">
					<div :key="JSON.stringify(item)">
						<v-badge :color="item"></v-badge>
					</div>
				</template>
			</v-select>
			<v-text-field
				v-if="editMode"
				v-model="form.price"
				type="number"
				label="Precio (Relativo)"
				placeholder="Precio"
				filled
				persistent-hint
				hint="Asigna precio unitario"
				hide-details
				class="mr-2 mt-2"
				outlined
				dense
			/>
			<template>
				<v-col
					cols="12"
					md="4"
					class="text-left py-1 my-1"
					v-if="dates.length && (form.person || form.person)"
				>
					<v-checkbox
						dense
						hide-details
						small
						class="my-1 py-1"
						style="display: inline-block"
						v-model="form.setHistories"
						label="Habilitar registro de ingreso y salida"
						v-if="showCheckInButton"
						:persistent-hint="!showCheckInButton"
					>
					</v-checkbox>
					<span class="caption error--text" v-else>
						<v-icon fab rounded x-small class="error--text">mdi-close</v-icon>
						Para habilitar la asistencia, la(s) persona(s) seleccionada deben ser
						personas convertidas a usuarios.</span
					>
					<v-checkbox
						dense
						hide-details
						small
						class="my-1 py-1"
						style="display: inline-block"
						v-model="form.setClientConfirmation"
						label="Habilitar confirmacion de actividad para el cliente"
						:persistent-hint="!showCheckInButton"
					>
					</v-checkbox>
				</v-col>
				<v-col
					cols="12"
					md="8"
					v-if="form.setHistories && showCheckInButton"
					class="my-1 py-1"
				>
					<v-menu
						ref="menuWorked"
						v-model="menuWorked"
						:close-on-content-click="false"
						max-width="290"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-combobox
								v-model="worked"
								:disabled="validateHours || !hasSalary"
								multiple
								style="max-width:200px"
								filled
								v-if="false"
								outlined
								hint="Marcar día(s) como trabajado(s)"
								persistent-hint
								prepend-icon="mdi-calendar"
								readonly
								dense
								v-bind="attrs"
								v-on="on"
							>
								<template v-slot:selection="{ attrs, item, parent, selected }">
									<v-chip v-bind="attrs" label small :input-value="selected">
										<span class="pr-2">
											{{ item }}
										</span>
										<v-icon small @click="parent.selectItem(item)">
											mdi-close
										</v-icon>
									</v-chip>
								</template>
							</v-combobox>
						</template>
						<v-date-picker
							v-model="worked"
							@change="menuWorked = false"
							multiple
							:min="form.start"
							:max="form.end"
							locale="es"
							no-title
						>
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="menuWorked = false">
								Cancel
							</v-btn>
							<v-btn text color="primary" @click="$refs.menuWorked.save(worked)">
								OK
							</v-btn>
						</v-date-picker>
					</v-menu>
					<div v-if="validateHours || !hasSalary" class="caption text--secondary">
						Algunas de la personas no tiene horario o salario asignado
					</div>
				</v-col>
			</template>
			<v-col cols="12" class="my-1 py-1">
				<v-btn
					:loading="loading"
					:disabled="
						loading || !(form.group && dates && form.person && form.room && form.place)
					"
					small
					class="ma-2"
					color="success"
					@click="saveLodging"
				>
					<template v-if="editMode">
						<v-icon small left>mdi-content-save-outline</v-icon>
						Actualizar
					</template>
					<template v-else>
						<v-icon small left>mdi-content-save-outline</v-icon>Agregar
					</template>
				</v-btn>
				<span class="caption error--text">{{
					!form.group
						? 'Sin periodo'
						: !dates.length
						? 'Sin fecha'
						: !form.person
						? 'Sin personas'
						: !form.room
						? 'Sin etiqueta'
						: !form.place
						? 'Sin lugar'
						: ''
				}}</span>
			</v-col>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { setEarned } from '@/utils/lodging/setSalary';
import { isArray } from 'lodash';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
let moment = extendMoment(Moment);

export default {
	name: 'EditLodging',
	props: {
		close: {
			type: Function,
			default: () => null,
		},
		sendAllNotes: {
			type: Function,
			default: () => null,
		},
	},
	components: {
		createPerson: () => import('@/components/persons/CreatePerson'),
	},
	data() {
		return {
			fieldEmpty: '',
			menuWorked: false,
			worked: [],
			loading: false,
			isEditing: false,
			isEditingPerson: false,
			isEditingRoom: false,
			menu: false,
			dates: [],
			datePicker: [],
			radioDatePicker: 'Seleccionar por rango',
			form: null,
			dialogPerson: false,
			searchPerson: '',
		};
	},
	computed: {
		// errorCheckIn() {
		// 	const errors = [];
		// 	this.validateHours &&
		// 		errors.push(
		// 			'Esta persona le faltan asignar horarios en estas fechas de la actividad'
		// 		);
		// 	!this.hasSalary && errors.push('Esta persona no tiene salario asignado');
		// 	return errors;
		// },
		showCheckInButton() {
			if (!this.form.person || !this.form.person.length) return false;
			// obtenemos la persona
			let persons = [];
			if (isArray(this.form.person))
				this.form.person.map(person => persons.push(this.getPerson(person._id || person)));
			else persons.push(this.getPerson(this.form.person));
			return persons.every(person => person.isUser);
		},
		// valida si la persona tiene horario asignado segun la fecha de la actividad
		// retorna true pata desactivar el input worked
		validateHours() {
			// Si no hay persona seleccionada
			if (!this.form.person || !this.form.person.length || !this.form.setHistories)
				return true;

			// obtenemos la persona
			let persons = [];
			if (isArray(this.form.person))
				this.form.person.map(person => persons.push(this.getPerson(person._id || person)));
			else persons.push(this.getPerson(this.form.person));

			// guardamos la fecha de comienzo y fin
			// isoWeekDay devuelve el dia como numero es decir Lunes = 1, martes = 2... etc
			const start = moment(this.form.start).isoWeekday();
			const end = moment(this.form.end).isoWeekday();

			// verificamos que todas las personas tengan horario dentro de los dias de la actividad marcados
			const hasNull = (hour, i) => !hour && i + 1 >= start && i + 1 <= end;

			return persons.some(person => person.start.some(hasNull) && person.end.some(hasNull));
		},
		// return true si todas las personas seleccionada tienen salario
		hasSalary() {
			// Si no hay persona seleccionada
			if (!this.form.setHistories || !this.form.person || !this.form.person.length)
				return false;
			// obtenemos la persona
			let persons = [];
			if (isArray(this.form.person))
				this.form.person.map(person => persons.push(this.getPerson(person._id || person)));
			else persons.push(this.getPerson(this.form.person));
			return persons.every(person => person.salary);
		},
		isToday() {
			if (this.form) {
				if (this.form.start && this.form.end)
					return moment().isBetween(
						moment(this.form.start),
						moment(this.form.end),
						'day',
						'[]'
					);
			}
			return false;
		},
		itemsAutocompleteRooms() {
			let roomNames = [];
			let roomNamesSet = new Set();
			if (
				!roomNamesSet.has({
					value: 'Sin etiqueta',
					text: 'Sin etiqueta',
				})
			)
				roomNamesSet.add({
					value: 'Sin etiqueta',
					text: 'Sin etiqueta',
				});
			this.lodgings.forEach(lod => {
				if (
					lod.room &&
					!roomNamesSet.has({
						value: lod.room,
						text: lod.room,
					})
				)
					roomNamesSet.add({
						value: lod.room,
						text: lod.room,
					});
			});
			roomNamesSet.forEach(item => {
				roomNames.push(item);
			});

			return roomNames;
		},
		itemsAutocompletePeriods() {
			let periodNames = [];
			let groupNamesSet = new Set();
			if (
				!groupNamesSet.has({
					value: 'Sin periodo',
					text: 'Sin periodo',
				})
			)
				groupNamesSet.add({
					value: 'Sin periodo',
					text: 'Sin periodo',
				});
			this.lodgings.forEach(lod => {
				if (
					lod.group &&
					!groupNamesSet.has({
						value: lod.group,
						text: lod.group,
					})
				)
					groupNamesSet.add({
						value: lod.group,
						text: lod.group,
					});
			});
			groupNamesSet.forEach(item => {
				periodNames.push(item);
			});

			return periodNames;
		},
		itemsAutocompletePersons() {
			if (this.listPerson && this.listPerson.length)
				return this.listPerson.map(item => ({
					value: item._id,
					text: ` ${item.firstName.toUpperCase()} ${
						item.lastName ? item.lastName.toUpperCase() : ''
					} ${item.rut ? '[' + item.rut + ']' : ''}`,
				}));
			return [];
		},
		datePickerText() {
			if (!this.dates) return;
			return this.dates.map(item => {
				if (item.length == 2) return item.join(' ~ ');
				return item;
			});
		},
		itemsColor() {
			return [
				'red',
				'teal',
				'grey',
				'pink',
				'lime',
				'indigo',
				'blue',
				'green',
				'brown',
				'cyan',
				'purple',
				'yellow',
				'amber',
				'orange',
			];
		},
		arrayEvents() {
			if (this.editMode) return [];
			const items = [];
			const today = moment().format('YYYY-MM-DD');
			const lodgings = this.lodgings.filter(lodging => {
				let mismoLugar = lodging.place == this.form.place;
				let dentroDelMes =
					moment(today).isSameOrAfter(lodging.start) ||
					moment(today).isSameOrBefore(lodging.end);
				return mismoLugar && dentroDelMes;
			});

			lodgings.map(lodging => {
				if (lodging.start == lodging.end) items.push(lodging.start);
				else {
					const range = moment().range(lodging.start, lodging.end);
					const array = Array.from(range.by('days'));
					array.map(m => {
						items.push(m.format('YYYY-MM-DD'));
					});
				}
			});
			return items;
		},
		...mapGetters({
			editMode: 'Lodging/editMode',
			listPerson: 'Person/persons',
			selectedService: 'Lodging/selectedService',
			itemEmpty: 'Lodging/itemEmpty',
			rooms: 'Room/rooms',
			lodgings: 'Lodging/lodgings',
			periods: 'Lodging/periods',
			lodgingSelect: 'Lodging/lodgingSelect',
			selectedPlace: 'Lodging/selectedPlace',
			countLogingsPlace: 'Lodging/countLogingsPlace',
			places: 'Lodging/places',
			lodgingForm: 'Lodging/lodgingForm',
		}),
	},
	watch: {
		lodgingForm(newValue) {
			const { person, visit } = newValue;
			const { dates, ...values } = visit;
			this.form = values;
			this.form.person = [person._id];
			this.dates = dates;
		},
		dates(newValue) {
			if (!newValue) {
				this.dates = [];
			}
		},
		lodgingSelect(newValue) {
			if (newValue) {
				this.form = { ...newValue };
				this.dates = [];
				if (this.lodgingSelect.start !== this.lodgingSelect.end)
					this.dates.push([this.lodgingSelect.start, this.lodgingSelect.end]);
				else this.dates.push([this.lodgingSelect.start]);
				this.setWorkedDay();
				// if (newValue.start !== newValue.end)
				// 	this.dates.push([newValue.start, newValue.end]);
				// else this.dates.push([newValue.start]);
			} else {
				this.form = this.defaultForm();
				this.dates = [];
				this.worked = [];
				this.setModeEdit(false);
			}
		},
		editMode(newValue) {
			if (!newValue) this.dates = [];
		},
		selectedPlace(newValue) {
			if (newValue) {
				this.defaultForm();
			}
		},
	},
	created() {
		this.form = this.defaultForm();
	},
	mounted() {
		if (this.selectedPlace) this.form.place = this.selectedPlace._id;
		if (this.itemEmpty) {
			if (this.itemEmpty.dateAlltimeline) {
				this.form.group = this.itemEmpty.group;
				this.form.person = this.itemEmpty.person;
				this.form.place = this.itemEmpty.place;
				this.dates.push([
					this.itemEmpty.dateAlltimeline.numberDay,
					this.itemEmpty.dateAlltimeline.numberDay,
				]);
			}
		}
		if (this.lodgingSelect) {
			this.form = { ...this.lodgingSelect };
			this.dates = [];
			if (this.lodgingSelect.start !== this.lodgingSelect.end)
				this.dates.push([this.lodgingSelect.start, this.lodgingSelect.end]);
			else this.dates.push([this.lodgingSelect.start]);
			this.setWorkedDay();
			// if (this.lodgingSelect.start !== newValue.end)
			// 	this.dates.push([newValue.start, newValue.end]);
			// else this.dates.push([newValue.start]);
		}
	},
	methods: {
		hasChangePerson() {
			this.form.setHistories = false;
			this.worked = [];
		},
		defaultForm() {
			this.worked = [];
			this.dates = [];
			this.fieldEmpty = '';
			return {
				setHistories: false,
				start: '',
				end: '',
				person: null,
				group: 'Sin periodo',
				room: 'Sin etiqueta',
				totalDays: 0,
				service: null,
				histories: [],
				price: 0,
				color: '',
			};
		},
		setWorkedDay() {
			this.worked = this.form.histories.filter(history => history.worked);
			this.worked = this.worked.map(item => moment(item.worked).format('YYYY-MM-DD'));
		},
		getPerson(id) {
			return this.listPerson.find(person => person._id == id);
		},
		/**
		 * Verifica el solapamiento de actividades
		 * @param {Object} item actividad
		 * @returns {Array}
		 */
		hasOverlay() {
			let verificate = [];
			const checkingPerson = personVerify => {
				const idLod = this.lodgingSelect ? this.lodgingSelect._id : '';
				let lodgingFilter = this.lodgings.filter(
					lod =>
						lod._id != idLod &&
						lod.person == personVerify &&
						this.form.group == lod.group &&
						lod.place == this.form.place
				);
				lodgingFilter.forEach(lod => {
					if (
						this.dates.some(date => {
							if (isArray(date)) {
								return (
									(moment(date[0]).isSameOrAfter(lod.start) &&
										moment(date[0]).isSameOrBefore(lod.end)) ||
									(moment(date[1]).isSameOrAfter(lod.start) &&
										moment(date[1]).isSameOrBefore(lod.end))
								);
							} else {
								return (
									moment(date).isSameOrAfter(lod.start) &&
									moment(date).isSameOrBefore(lod.end)
								);
							}
						})
					) {
						const person = this.getPerson(lod.person);
						this.setLodgingWithProblems(lod);
						verificate.push(`${person.firstName} ${person.lastName}`);
					}
				});
			};
			if (this.editMode) checkingPerson(this.form.person);
			else this.form.person.forEach(personVerify => checkingPerson(personVerify));
			return verificate;
		},
		setFormData() {
			this.setLodgingWithProblems(null);
			// remueve historias de dias pre seleccionados
			if (this.editMode) this.removeWorked();
			// agrega historias con los dias pre seleccionados
			if (this.worked.length) {
				if (this.editMode) {
					const temp = this.form.histories.map(item => {
						if (item.worked) {
							return moment(item.worked).format('l');
						}
					});
					this.worked = this.worked.filter(
						item => !temp.includes(moment(item).format('l'))
					);
					this.worked.forEach(date => {
						this.form.histories.push({
							in: moment(date),
							worked: moment(date),
							earned: setEarned(this.getPerson(this.form.person)),
						});
					});
				} else {
					const persons = isArray(this.form.person)
						? this.form.person
						: [this.form.person];
					this.form.person = persons.map(idPerson => {
						return {
							_id: idPerson,
							histories: this.worked.map(date => ({
								in: moment(date),
								worked: moment(date),
								earned: setEarned(this.getPerson(idPerson)),
							})),
						};
					});
				}
			}
			// reseteo de propiedades si la persona cambia
			if (this.editMode && this.form.person != this.lodgingSelect.person) {
				this.setHistories = false;
				this.form.histories = [];
				this.form.documents = [];
				this.form.notes = [];
			}
			//seteo de room
			const nameRoom = this.form.room.text;
			const nameRoomText = this.form.room;
			delete this.form.room;
			//seteo de group
			const namePeriod = this.form.group.text;
			const namePeriodText = this.form.group;
			delete this.form.group;
			const place = this.places.find(place => place._id == this.form.place);
			const formattedData = {
				service: this.selectedService || place.services[0],
				room: typeof nameRoomText == 'string' ? nameRoomText : nameRoom,
				group: typeof namePeriodText == 'string' ? namePeriodText : namePeriod,
			};

			this.form = Object.assign(this.form, { ...formattedData });
		},
		async updateLodgingData() {
			let idPlaces = [];
			if (this.selectedPlace && this.$route.name == 'activities')
				idPlaces.push(this.selectedPlace._id);
			else idPlaces = this.places.map(place => place._id);

			// set date start and end
			// this.dates aveces es un "[[]]" cuando se cambia la fecha de lo contrario es []
			// array dates en la posicion [0] si se cambia tendra dos posiciones
			this.form.start =
				this.dates[0].length == 2 ? this.dates[0][0] : this.lodgingSelect.start;
			this.form.end = this.dates[0].length == 2 ? this.dates[0][1] : this.lodgingSelect.end;

			this.form.place =
				typeof this.form.place == 'string' ? this.form.place : this.form.place._id;
			const payload = { lodging: this.form, idPlaces };
			await this.updateLodging(payload);
		},
		async addLodging() {
			let idPlaces = [];
			if (this.selectedPlace) idPlaces.push(this.selectedPlace._id);
			else idPlaces = this.places.map(place => place._id);
			this.form.dates = this.dates;
			const payload = { lodging: this.form, idPlaces };
			const newLodgings = await this.createLodging(payload);
			this.sendAllNotes(newLodgings);
			this.form = this.defaultForm();
		},
		async removeWorked() {
			if (!this.worked.length)
				return (this.form.histories = this.lodgingSelect.histories.filter(
					item => !item.worked
				));

			return (this.form.histories = this.lodgingSelect.histories.filter(
				item =>
					!item.worked || this.worked.includes(moment(item.worked).format('YYYY-MM-DD'))
			));
		},
		async saveLodging() {
			if (this.editMode && !this.hasChangesToSave())
				return this.snackbar({
					content: 'Sin cambios para guardar',
					color: 'info',
				});
			if (!(this.form.group && this.dates && this.form.person && this.form.room)) {
				return this.snackbar({
					content: 'Falta campo por llenar: ' + this.fieldEmpty,
					color: 'info',
				});
			}
			this.loading = true;
			let overlayProblems = this.hasOverlay();
			if (overlayProblems.length) {
				this.$emit('deleteLodgingOK');
				this.snackbar({
					content: `Existe solapamiento de actividades`,
					color: 'warning',
				});
			} else {
				this.setFormData();
				this.editMode ? await this.updateLodgingData() : await this.addLodging();
				this.defaultForm();
			}
			this.loading = false;
		},
		personFilter(item, queryText, itemText) {
			if (queryText === undefined || itemText === undefined) {
				return false;
			}
			const buscarListaPalabras = queryText
				.trim()
				.toLowerCase()
				.split(' ');
			itemText = itemText.trim().toLowerCase();

			let contar = 0;
			buscarListaPalabras.forEach(b => {
				if (itemText.indexOf(b) > -1) {
					contar++;
				}
			});

			return buscarListaPalabras.length === contar;
		},
		hasChangesToSave() {
			let worked = this.lodgingSelect.histories.filter(item => item.worked);
			worked = worked.map(item => moment(item.worked).format('YYYY-MM-DD'));
			const hasChangeWorked = this.worked.filter(item => !worked.includes(item));
			return (
				moment(this.lodgingSelect.start).format('l') != moment(this.dates[0]).format('l') ||
				moment(this.lodgingSelect.end).format('l') != moment(this.dates[1]).format('l') ||
				this.form.person != this.lodgingSelect.person ||
				this.form.color != this.lodgingSelect.color ||
				this.form.group != this.lodgingSelect.group ||
				this.form.room != this.lodgingSelect.room ||
				this.form.price != this.lodgingSelect.price ||
				this.form.setHistories != this.lodgingSelect.setHistories ||
				this.form.setClientConfirmation != this.lodgingSelect.setClientConfirmation ||
				this.worked.length != worked.length ||
				hasChangeWorked.length
			);
		},
		async setPerson(id) {
			if (this.editMode) {
				this.form.person = id;
				await this.saveLodging();
			} else {
				if (isArray(this.form.person)) this.form.person.push(id);
				else this.form.person = [id];
			}
		},

		setDateInput() {
			if (this.hasOverlayDatePicker()) {
				return this.snackbar({
					content: 'Alguno de los dias que selecciono ya estaba presente',
					color: 'info',
				});
			} else {
				if (this.editMode) this.dates = [];
				if (this.radioDatePicker == 'Seleccionar por rango') {
					//Ordenar fechas
					let values = [null, null];
					if (moment(this.datePicker[0]).isSameOrBefore(this.datePicker[1])) {
						values[0] = this.datePicker[0];
					} else {
						moment(this.datePicker[1]).isSameOrBefore(this.datePicker[0]);
						values[0] = this.datePicker[1];
					}
					if (moment(this.datePicker[0]).isSameOrAfter(this.datePicker[1])) {
						values[1] = this.datePicker[0];
					} else {
						moment(this.datePicker[1]).isSameOrAfter(this.datePicker[0]);
						values[1] = this.datePicker[1];
					}
					this.dates.push(values);
				} else this.datePicker.forEach(item => this.dates.push(item));
			}
			this.datePicker = [];
			this.menu = false;
		},
		hasOverlayDatePicker() {
			if (!this.dates) return false;
			// iteramos las fechas seleccionadas
			return this.datePicker.some(item => {
				// buscamos si coincide con alguna en el array de dates
				return this.dates.some(date => {
					// case 1 date es un array, esto cuando son un rango
					if (isArray(date))
						return (
							moment(item).isSameOrAfter(date[0]) &&
							moment(item).isSameOrBefore(date[1])
						);
					// case 2 date es un string, cuando es por dia
					else return item == date;
				});
			});
		},
		...mapMutations({
			setLodgingWithProblems: 'Lodging/setLodgingWithProblems',
			setModeEdit: 'Lodging/setModeEdit',
			snackbar: 'Snackbar/showMessage',
		}),
		...mapActions({
			createLodging: 'Lodging/createLodging',
			updateLodging: 'Lodging/updateLodging',
		}),
	},
};
</script>

<style lang="scss">
.bordeCol {
	border-bottom: 1px solid #be66ea38;
}
.input-prices {
	input {
		padding: 0px !important;
	}
}
</style>
